<template>
  <div class="complaint">
    <v-container>
      <div class="d-flex flex-row">
        <v-icon color="#7ec352">info</v-icon>
        <h1 class="font-weight-bold mrx-1">{{oracle.translate('برای ثبت شکایت خود فرم زیر را تکمیل کنید.')}}</h1>
      </div>
      <v-row>
        <v-col cols="4">
          <div class="fieldProfile-contact">
            <label> <span>*</span>{{oracle.translate('عنوان انتقادات و پیشنهادات:')}}</label>
            <v-text-field
                v-model="title"
                dir="ltr"
                solo
                hide-details
                :placeholder="oracle.translate('عنوان انتقادات و پیشنهادات')"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="4">
          <div class="fieldProfile-contact">
            <label> <span>*</span>{{oracle.translate('نام و نام خانوادگی:')}}</label>
            <v-text-field
                v-model="name"
                dir="ltr"
                solo
                hide-details
                :placeholder="oracle.translate('نام و نام خانوادگی')"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="4">
          <div class="fieldProfile-contact">
            <label>{{oracle.translate('شماره تماس یا ایمیل: (اختیاری)')}}</label>
            <v-text-field
                v-model="number"
                dir="ltr"
                solo
                hide-details
                :placeholder="oracle.translate('شماره تماس یا ایمیل')"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="4">
          <div class="fieldProfile-contact">
            <label> <span>*</span>{{oracle.translate('متن انتقادات و پیشنهادات:')}}</label>
            <v-textarea
                v-model="note"
                dir="ltr"
                name="input-7-4"
                hide-details
                solo
                :placeholder="oracle.translate('متن نظر و پیشنهاد')"
            ></v-textarea>
          </div>
        </v-col>
      </v-row>
      <v-col cols="3">
        <v-btn color="#7ec352" class="btn-submit" v-ripple role="button" @click="sendRequest">
          {{oracle.translate('ارسال فرم درخواست')}}
        </v-btn>
      </v-col>
    </v-container>
  </div>
</template>
<script>
import oracle from "@/oracle";

export default {
  name: "complaint",
  data: () => ({
    number: null,
    name: null,
    note: null,
    title: null,
    oracle: oracle
  }), components: {},
  methods: {
    sendRequest() {
      let data = {
        "name": this.name,
        "number": this.number,
        "note": this.note,
        "title": this.title,
        "isSuggest": true,
      }
      oracle.axios("vendor/informSupport", data, this.showSuccess)
    }, showSuccess(response) {
      this.name = null
      this.number = null
      this.note = null
      this.title = null
      oracle.showSuccess(oracle.translate('پیام شما با موفقیت ثبت شد')
          + '<br>'
          + oracle.translate('لطفا منتظر تماس از سمت تیم پشتیبانی باشید!') + '\n')
    }
  }
};
</script>
<style>
.complaint {
  background: #fff;
}

.complaint h1 {
  font-size: 14px;
  color: #333;
  margin: 30px 15px;
}

.complaint .fieldProfile-contact,
.complaint .fieldArea {
  margin: 0 15px !important;
  color: #acaca8;
}

.complaint .fieldProfile-contact span {
  color: red;
  font-size: 15px;
  padding: 2px;
}

.complaint .fieldProfile-contact::placeholder {
  color: #333 !important;
  font-size: 12px;
  padding: 10px 0;
}

.complaint .fieldProfile-contact {
  font-size: 12px;
  padding: 5px 0;
}

.complaint .fieldProfile-contact .v-textarea textarea {
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
}

.complaint.fieldProfile-contact .v-text-field input,
.complaint .fieldProfile-contact .vpd-input-group input,
.complaint .fieldProfile-contact .v-textarea textarea {
  font-size: 12px;
  text-align: end;
}

.complaint .fieldProfile-contact
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot {
  box-shadow: none !important;
}

.complaint .fieldProfile-contact .v-text-field.v-text-field--solo .v-input__control {
  min-height: 40px !important;
  margin: 8px 0;
}

.complaint .fieldProfile-contact,
.complaint .fieldArea {
  margin: 0 15px !important;
  color: #acaca8;
}

.complaint .fieldProfile-contact span {
  color: red;
  font-size: 15px;
  padding: 2px;
}

.complaint .fieldProfile-contact label {
  color: #333 !important;
  font-size: 12px;
  padding-top: 20px;
  margin-top: 5px;
}

.complaint .fieldProfile-contact {
  font-size: 12px;
}

.complaint .fieldProfile-contact .v-textarea textarea {
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
}

.complaint .fieldProfile-contact .v-text-field input,
.complaint .fieldProfile-contact .vpd-input-group input,
.complaint .fieldProfile-contact .v-textarea textarea {
  font-size: 12px;
  text-align: end;
}

.complaint .fieldProfile-contact
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #ced4da;
  border-radius: 5px;
}

.complaint .fieldProfile-contact .v-text-field.v-text-field--solo .v-input__control {
  min-height: 40px !important;
  margin: 8px 0;
}


.complaint .btn-submit {
  color: #fff !important;
  height: 40px !important;
  padding: 0 20px !important;
  border-radius: 3px !important;
  margin: 20px 15px !important;
}
</style>
